import { Type } from 'class-transformer'
import { IsInt, IsNumber, IsPositive } from 'class-validator'

export class DocumentCopyDto {
  @Type(() => Number)
  @IsNumber()
  @IsInt()
  @IsPositive()
  targetInspectionId!: number
}
